module.exports = __webpack_public_path__ + "static/1-7dd3f4fa395376ec47e8267687f3056a.png";